import { useState, useEffect } from 'react'

function DelayUnmountChild(props: {
  isMountChild: boolean,
  delayTime?: number,
  children: JSX.Element,
}) {
  const shouldRenderChild = useDelayUnmount(props.isMountChild, props.delayTime ? props.delayTime : 300);

  return (
    <>
    {shouldRenderChild && props.children}
    </>
  )
}

function useDelayUnmount(isMounted: boolean, delayTime: number) {
  const [ shouldRender, setShouldRender ] = useState(false);

  useEffect(() => {
      let timeoutId: number
      if (isMounted && !shouldRender) {
          setShouldRender(true);
      }
      else if(!isMounted && shouldRender) {
          timeoutId = window.setTimeout(
              () => setShouldRender(false), 
              delayTime
          );
      }
      return () => clearTimeout(timeoutId);
  }, [isMounted, delayTime, shouldRender]);
  return shouldRender;
}

export default DelayUnmountChild